import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { getArticles } from '../services/api';
import { NewsCard } from '../components/news/NewsCard';
import { Skeleton } from '../components/ui/skeleton';
import { Search } from 'lucide-react';
import { Input } from '../components/ui/input';
import { Button } from '../components/ui/button';

export default function SearchPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const { t, isKannada } = useLanguage();
  const [query, setQuery] = useState(searchParams.get('q') || '');
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(false);

  const doSearch = async (q) => {
    if (!q.trim()) return;
    setLoading(true);
    try {
      const res = await getArticles({ search: q, limit: 20 });
      setArticles(res.data.articles || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const q = searchParams.get('q');
    if (q) { setQuery(q); doSearch(q); }
  }, [searchParams]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSearchParams({ q: query });
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-testid="search-page">
      <form onSubmit={handleSubmit} className="flex gap-3 mb-8 max-w-xl mx-auto">
        <Input value={query} onChange={(e) => setQuery(e.target.value)}
          placeholder={t('searchPlaceholder')}
          className="bg-white dark:bg-stone-900 border-stone-300 dark:border-stone-700"
          data-testid="search-page-input" />
        <Button type="submit" className="bg-saffron hover:bg-saffron-dark text-white rounded-sm px-6" data-testid="search-submit-btn">
          <Search className="w-4 h-4" />
        </Button>
      </form>

      {loading ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {[1,2,3].map(i => <Skeleton key={i} className="h-72" />)}
        </div>
      ) : articles.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {articles.map(a => <NewsCard key={a.article_id} article={a} />)}
        </div>
      ) : searchParams.get('q') ? (
        <p className="text-center text-stone-400 py-16 text-lg">{t('noResults')}</p>
      ) : null}
    </div>
  );
}
